import { defineMessages } from "react-intl";

const PREFIX = "RecentlyUsedSlides";
export default defineMessages({
  headerLabel: {
    id: `${PREFIX}.header.label`,
    defaultMessage: "Recently used slides",
  },
  headerMore: {
    id: `${PREFIX}.header.more`,
    defaultMessage: "More slides",
  },
  dateLastOpened: {
    id: `${PREFIX}.content.date.lastOpened`,
    defaultMessage: "Last opened:",
  },
});
